import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from "reactstrap";
import useGlobal from '../../store';


const EditGiftlistForm = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    useEffect(() => {
        if(!response || response.type !== "updategiftlist") {
            return;
        }
        setIsSaving(false);
    }, [response])

    const [formState, setFormState] = useState({
        userID: props.userID,
        FirstName: props.FirstName,
        LastName: props.LastName,
        about: props.about,
        gender: props.gender || 'male',
        ageRange: props.ageRange || 'adult'
    });

    const submitForm = async (event) => {
        event.preventDefault();
        setIsSaving(true);
        const justFormData = new FormData(event.target);
        var object = {};
        justFormData.forEach((value, key) => {object[key] = value});
        const formData = { ...formState };
        console.log('FORM DATA', formData);
        userActions.updateUserProfile(formData);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    const genderOptions = ['male', 'female'];
    const ageRangeOptions = ['baby','toddler','child','teen','young-adult','adult','senior'];

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right">

            <div className="form-group">
                <label>First Name</label>
                <input type="text" name="FirstName" value={formState.FirstName || ''} onChange={handleInputChange} className="form-control" aria-describedby="emailHelp" placeholder="First Name" />
            </div>

            <div className="form-group">
                <label>Last Name</label>
                <input type="text" name="LastName" value={formState.LastName || ''} onChange={handleInputChange} className="form-control" aria-describedby="emailHelp" placeholder="Last Name" />
            </div>

            <div className="form-group">
                <label>About {formState.FirstName}</label>
                <span className="form-text text-muted">Provide a short description of {formState.FirstName}'s interests, hobbies, clothing sizes, etc. to help others find a great gift.</span>
                <Input type="textarea" name="about" value={formState.about || ''} onChange={handleInputChange} options={genderOptions}></Input>
            </div>

            <div className="form-group">
                <label>Gender</label>
                <Input type="select" name="gender" value={formState.gender || ''} onChange={handleInputChange} >
                    {genderOptions.map(opt => <option key={opt}>{opt}</option>)}
                </Input>
            </div>

            <div className="form-group">
                <label>Age Range</label>
                <Input type="select" name="ageRange" value={formState.ageRange || ''} onChange={handleInputChange}>
                    {ageRangeOptions.map(opt => <option key={opt}>{opt}</option>)}
                </Input>
            </div>
            
            <div className="form-group">
                <Button color="success" type="submit">
                    Save Changes
                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                </Button>
            </div>
            
        </Form>);
}
export default EditGiftlistForm;